const trips = {
  table: {
    headers: {
      from: 'Local de Recolhimento',
      to: 'Local de Deixa',
      seats: 'Quantidade de Item',
      passenger: 'Nome do Destinatário',
    },
  },
};

export default trips;
